import {
  LDSButton,
  LDSDialog,
  LDSHeading,
} from "@resmed/lumina-design-system";
import type { ParticipantItem } from "../../features/chat/types";
import ParticipantListItem from "../ParticipantListItem";

export interface ViewParticipantsDialogProps {
  visible: boolean;
  participants: ParticipantItem[];
  onCancel: () => void;
}

const ViewParticipantsDialog = ({
  visible,
  participants,
  onCancel,
}: ViewParticipantsDialogProps) => {
  return (
    <LDSDialog
      id="view-participants-dialog"
      headerTitle="View participants"
      visible={visible}
      onHide={onCancel}
      dismissable={true}
      closeOnEscape={true}
      blockScroll={true}
      fullScreenIcon={false}
      size="medium"
      rootClassName="lds-w-[90vw] lds-max-w-2xl"
      contentClassName="lds-p-0"
      footer={
        <div className="lds-flex lds-justify-start lds-pb-3">
          <LDSButton
            id="view-participants-close"
            label="Cancel"
            severity="secondary"
            outlined
            onClick={onCancel}
          />
        </div>
      }
    >
      <div className="lds-pb-2 lds-pt-4">
        <div className="lds-rounded-lg lds-border lds-border-bordercolor-default lds-bg-bgcolor-default lds-p-4">
          <LDSHeading
            size="h5"
            className="lds-mb-4 lds-font-semibold lds-text-textcolor-default"
          >
            Participants details
          </LDSHeading>

          <div className="lds-max-h-[50vh] lds-space-y-3 lds-overflow-y-auto lds-pr-1">
            {participants.length > 0 ? (
              participants.map((participant) => (
                <ParticipantListItem
                  key={`${participant.userId}-${participant.roleId}`}
                  displayName={participant.displayName}
                  roleName={participant.roleName}
                  avatar={participant.avatar}
                  borderless
                  inlineDetails
                />
              ))
            ) : (
              <LDSHeading
                size="h5"
                className="lds-font-normal lds-text-sm lds-text-textcolor-caption"
              >
                No participants found.
              </LDSHeading>
            )}
          </div>
        </div>
      </div>
    </LDSDialog>
  );
};

export default ViewParticipantsDialog;
